<template>
  <form class="form" method="post">

    <div id="appSpendingEditVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <h2>Modifier ma dépense</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Date débit*</p>
            <p class="appLabelStyle1">Catégorie*</p>
            <p class="appLabelStyle1">Fournisseur</p>
            <p class="appLabelStyle1">Référence</p>
            <p class="appLabelStyle1">Montant*</p>
            <p class="appLabelStyle1">Paiement*</p>
          </div>
          <div class="appGroupOfInput">
            <input v-model="spending.date" type="date" name="date" class="appInputStyle1">
            <select v-model="spending.category" type="select" name="category" class="appInputStyle1">
              <option valeur="femme">Consommables</option>
              <option valeur="homme">Matériel</option>
              <option valeur="femme">Consommables + Matériel</option>
              <option valeur="homme">Assurance</option>
              <option valeur="femme">Essence</option>
              <option valeur="homme">Frais bancaires</option>
              <option valeur="homme">Salaire</option>
              <option valeur="homme">Téléphone</option>
              <option valeur="homme">URSSAF</option>
              <option valeur="homme">Autres</option>
            </select>
            <input v-model="spending.supplier" type="string" name="supplier" class="appInputStyle1">
            <input v-model="spending.reference" type="string" name="reference" class="appInputStyle1">
            <input v-model="spending.price" type="number" step='0.01' name="price" class="appInputStyle1">
            <select v-model="spending.typeofpaiement" type="string" name="typeofpaiement" class="appInputStyle1">
              <option valeur="Espèces">Espèces</option>
              <option valeur="Chèque">Chèque</option>
              <option valeur="CB">CB</option>
              <option valeur="Virement">Virement</option>
            </select>
          </div>
        </div>
      </div>
      <button @click.prevent="modifySpending()" type="submit" class="appButtonModel2">Corriger ma dépense</button>
      <br>
      <button @click.prevent="deleteSpending()" type="submit" class="appButtonModel2">Supprimer ma dépense</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'ProductEdit',
  data () {
    return {
      date: '',
      reference: '',
      supplier: '',
      category: '',
      price: '',
      typeofpaiement: '',
      errorMsg: '',
      spending: ''
    }
  },
  mounted () {
    const url = document.location.href
    const idToModify = url.substring(url.lastIndexOf('=') + 1)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/depenses/' + idToModify), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.spending = response.data
      })
  },
  methods: {
    modifySpending () {
      // Test si champs remplis
      if (this.date !== null || this.reference !== null || this.supplier !== null || this.category !== null || this.price !== null || this.typeofpaiement !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage + ID produit
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        const url = document.location.href
        const idToModify = url.substring(url.lastIndexOf('=') + 1)
        axios
          .put('https://privilegia.fr/api/depenses/' + idToModify,
            {
              'userId': decryptedToken.userId,
              'date': this.spending.date,
              'reference': this.spending.reference,
              'supplier': this.spending.supplier.toUpperCase(),
              'category': this.spending.category,
              'price': this.spending.price,
              'typeofpaiement': this.spending.typeofpaiement
            }, { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            window.alert('Données de la dépenses modifiées')
            this.$router.push('/App/Spendings')
          })
          .catch((error) => {
            this.errorMsg = 'Merci de renseigner tous les champs'
            console.log(error.response.data)
          })
        // Si des champs sont vides
      } else {
        this.errorMsg = 'Merci de renseigner tous les champs'
      }
    },
    deleteSpending () {
      if (window.confirm('Supprimer cette dépense ?')) {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const url = document.location.href
        const idToDelete = url.substring(url.lastIndexOf('=') + 1)
        axios
          .delete('https://privilegia.fr/api/depenses/' + idToDelete,
            { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            window.alert('Dépense supprimée')
            this.$router.push('/App/Spendings')
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      } else {
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppSpendingsEdit.vue